import React, { Fragment } from 'react';
import { Divider, Stack } from '@mui/material';
import { LineItemProduct } from './LineItemProduct';
import { Contract } from 'modules/contract/types';

interface ChooseLineItemStepActiveProps {
  completeStep(lineItemId: number): void
  contract?: Contract
}

export const ChooseLineItemStepActive: React.FC<ChooseLineItemStepActiveProps> = ({ contract, completeStep }) => {

  return (
    <Stack gap={3} marginLeft={7} marginTop={5}>
      {contract?.lineItems.map((lineItem, index) => (
        <Fragment key={lineItem.lineNumber}>
          {index > 0 && <Divider light />}
          <LineItemProduct product={lineItem.product} completeStep={() => completeStep(index)} />
        </Fragment>
      ))}
    </Stack>
  );
};